import "./Home.css";
// import img1 from "../../Images/ReviewImage/image1.png";
import {
  Nav,
  Hero,
  Footer,
  WorkBrand,
  RecentWork,
  QuickReview,
  Services,
  Testimonial,
  Social
} from "../../Components/ExportComponents";
import { useState } from "react";
import { Helmet } from "react-helmet"; // ✅ Import Helmet

const Home = () => {
  const [menuBar, setMenuBar] = useState(false);

  return (
    <>
      {/* Page-specific SEO */}
      <Helmet>
        <title>
          Best Graphic Designer & UI/UX Designer from Pokhara, Nepal | The Visual Designer
        </title>
        <meta
          name="description"
          content="The Visual Designer is the personal brand of Bhanubhakta Sapkota, offering graphic design, UI/UX design, branding, and digital marketing services worldwide."
        />
        <meta property="og:title" content="Best Graphic Designer & UI/UX Designer from Pokhara, Nepal | The Visual Designer" />
        <meta property="og:description" content="The Visual Designer is the personal brand of Bhanubhakta Sapkota, offering graphic design, UI/UX design, branding, and digital marketing services worldwide." />
        <meta property="og:image" content="https://thevisualdesigner.co/static/media/AuthorHero.cd911b13e8eeef5efb43.png" />
        <meta property="og:url" content="https://thevisualdesigner.co/" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Best Graphic Designer & UI/UX Designer from Pokhara, Nepal | The Visual Designer" />
        <meta name="twitter:description" content="The Visual Designer is the personal brand of Bhanubhakta Sapkota, offering graphic design, UI/UX design, branding, and digital marketing services worldwide." />
        <meta name="twitter:image" content="https://thevisualdesigner.co/static/media/AuthorHero.cd911b13e8eeef5efb43.png" />

        <link rel="canonical" href="https://thevisualdesigner.co/" />
      </Helmet>

      <div className="backgroundBig">
        <span className="mainBackgroundHR"></span>
        <span className="mainBackgroundHRleft"></span>
        <div className="mainBackgroundHRRight"></div>
        <span className="mainBackgroundHRright"></span>
        <span className="mainBackgroundBig"></span>
        <span className="mainBackgroundBigRight"></span>

        <div className="smallBack">
          <div className="topLeftInternal"></div>
          <div className="topLeftInternal2"></div>

          <div className="topRightInternal"></div>
          <div className="topRightInternal2"></div>
          <Nav setMenuBar={setMenuBar} menuBar={menuBar} />
          <Hero menuBar={menuBar} />
          <WorkBrand />
          <RecentWork />

          <div className="toFit">
            <QuickReview />
          </div>

          <Services />
          <Testimonial />
          <Social />
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Home;
